var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.list)?_c('v-data-table',{attrs:{"items":_vm.list,"loading":_vm.loading,"headers":_vm.headers,"footer-props":_vm.footerProps},scopedSlots:_vm._u([{key:"item.created",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("formatDate")(item.created))+" ")]}},{key:"item.annotationClass",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.annotationClass(item.annotation_class).class_name)+" ")]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('div',{class:{
          'green--text': item.status === 'accepted',
          'red--text': item.status === 'rejected'
        }},[_vm._v(" "+_vm._s(_vm.$t("contributions.pathologistTable.annotationStatus." + item.status.toLowerCase()))+" ")])]}}],null,false,3474341404)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }